// removed by extract-text-webpack-plugin
module.exports = {"main":"GridItem-main--1xQRB","label":"GridItem-label--2fIFP","content":"GridItem-content--1pibB","status-ok":"GridItem-status-ok--1uxqF","status-warning":"GridItem-status-warning--2YKUZ","status-problem":"GridItem-status-problem--1uLIy","status-disconnected":"GridItem-status-disconnected--1jJ7b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataPanel/GridItem/GridItem.scss
// module id = BiFx
// module chunks = 4